import { render, staticRenderFns } from "./BorrowAreaPopupEdit.vue?vue&type=template&id=ae04b93e&scoped=true"
import script from "./BorrowAreaPopupEdit.vue?vue&type=script&lang=js"
export * from "./BorrowAreaPopupEdit.vue?vue&type=script&lang=js"
import style0 from "./BorrowAreaPopupEdit.vue?vue&type=style&index=0&id=ae04b93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae04b93e",
  null
  
)

export default component.exports